import React, { useEffect, useState } from "react"
import "./index.scss"

export default function FilterBar({
  component,
  filtersValues,
  setFilters,
  filters,
  filterData,
}) {
  const [queryTags, setQueryTags] = useState([])
  const [tagsQuery, setTagsQuery] = useState([])

  const { headline, accentColor } = component

  // = = = = = = = = = = = = =
  // Hooks

  useEffect(() => {
    // 1. Get query parameters from url
    if (typeof window !== "undefined") {
      const queryParams = new URLSearchParams(window.location.search)
      queryParams.delete('utm_medium')
      queryParams.delete('utm_campaign')
      queryParams.delete('emci')
      queryParams.delete('emdi')
      queryParams.delete('ceid')
      
      // 2. For each query
      let tags = [];
      
      for (const [key, value] of queryParams.entries()) {
        // 3. Add query to Component State
        setQueryTags([{ key: key, value: value }])
        tags = [...tags, { key: key, value: value }]
        // 4. Call this helper
        setValuesInProperties(key, value.replaceAll("_", " "))
      }

    }
  }, [])

  // = = = = = = = =
  // Event Handlers

  const handleChange = e => {
    const filterProperty = e.target.id
    const filterValue = e.target.value
    setValuesInProperties(filterProperty, filterValue)

    setQueryTags([{ key: e.target.name, value: e.target.value }])
  
  }

  const handleSubmit = e => {
    e.preventDefault()
    filterData()
  }

  // = = = = = = = =
  // Helpers

  const setValuesInProperties = (property, value) => {
    let updatedFilters = filters

    if (!filters.some(filter => filter.hasOwnProperty(property))) {
      updatedFilters = filters?.concat({ [property]: value })
    } else if (value === "Select") {
      // If user selects 'Select' as value remove the property from the filter object
      updatedFilters = filters?.filter(
        filter => !filter.hasOwnProperty(property)
      )
    } else {
      // Remove object with same property and add new one if already exists
      updatedFilters = filters
        ?.filter(filter => !filter.hasOwnProperty(property))
        .concat({ [property]: value })
    }

    setFilters(updatedFilters)
  }

  // Returns value of tag from url if exist in select filters
  const getOptionValue = filter => {
    const filteredTag = queryTags.filter(tag => tag.key === filter.id)

    if (
      filter?.values
        ?.flat()
        .filter(n => n)
        .includes(filteredTag[0]?.value.replaceAll("_", " "))
    ) {
      return filteredTag[0]?.value.replaceAll("_", " ")
    }
  }

  return (
    <section
      data-datocms-noindex
      className={`filter-section ${
        accentColor ? `filter-section--${accentColor}` : null
      }`}
    >
      <div className="container">
        {headline && (
          <div className="row">
            <div className="col-md-12">
              <h2
                className={`filter-headline ${
                  accentColor ? `filter-headline--${accentColor}` : null
                } oblique`}
              >
                {headline}
              </h2>
            </div>
          </div>
        )}

        <div className="row">
          <div className="col-md-12">
            <form onSubmit={e => handleSubmit(e)} action="">
              <div className="inputs-wrapper">
                {filtersValues.map(filter => (
                  <div key={filter.id} className="select-wrapper">
                    <label htmlFor={filter.id}>{filter.label}</label>
                    <select
                      value={getOptionValue(filter)}
                      onChange={e => handleChange(e)}
                      name={filter.id}
                      id={filter.id}
                    >
                      <option>Select</option>
                      {
                        // 1. flat(1): Flat array
                        // 2. filter(value => value): Remove empty values
                        // 3. Remove repeated values from filter.values Array,
                        // 4. Create an html option for each one
                        [
                          ...new Set(
                            filter.values?.flat(1).filter(value => value)
                          ),
                        ].map(value => (
                          <option key={value} value={value}>
                            {value.replaceAll("-", " ")}
                          </option>
                        ))
                      }
                    </select>
                  </div>
                ))}
                <button
                  type="submit"
                  className="btn btn-primary btn--large btn--filter"
                >
                  Filter
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </section>
  )
}
